<template>
    <div component="Contract" template="page">
        <div class="bg">
            <v-card class="holder">
                <contract-header @onChange="onChange" />
                <contracts />
            </v-card>
        </div>
    </div>
</template>

<script>
import ContractHeader from '@/components/Contract/ContractHeader';
import Contracts from '@/components/Contract/Contracts';

export default {
    name: 'Contract',

    components: {
        ContractHeader,
        Contracts,
    },

    data() {
        return {
            loading: true,
            showProject: false,
        };
    },

    mounted() {},

    methods: {
        onChange() {},
    },

    computed: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Contract'] {
    height: 100vh;
    max-height: 100vh;

    .holder {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px 20px 10px;
        .radiusBig !important;
    }
}
</style>
